<template>
  <span>
    <v-btn
      class="mx-2"
      color="primary"
      @click="openPreview"
    >
      Preview Changes
    </v-btn>
    <v-btn
      color="primary"
      text
      @click="buildDialog"
    >
      Build
    </v-btn>
    <v-dialog
      v-model="dialog"
    >
      <material-card title="Build site">
        <v-card-text>
          {{ message }}
        </v-card-text>
        <v-btn
          v-if="tryAgain"
          color="primary"
          text
          @click="buildDialog"
        >
          Try Again
        </v-btn>
        <v-progress-circular
          v-if="loading"
          indeterminate
        />
        <template v-slot:actions>
          <v-spacer />

          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </template>
      </material-card>
    </v-dialog>
    <yes-no-dialog
      ref="yesno"
      @yes="build"
    />
  </span>
</template>

<script>
  import moment from 'moment'
  import YesNoDialog from './YesNoDialog'
  export default {
    components: {
      YesNoDialog
    },
    data () {
      return {
        loading: false,
        message: '',
        building: false,
        tryAgain: false,
        dialog: false,
        interval: null
      }
    },
    computed: {
      site: function () {
        return this.$store.state.site
      },
      sites: function () {
        return this.$store.state.sites
      }
    },
    methods: {
      moment,
      openPreview () {
        var site = this.sites.find(site => site.siteId === this.site)
        window.open('https://' + site.domain + '?preview=true', '_blank')
      },
      getLiveDate (site, onload) {
        fetch('https://' + site.domain + '/updates.txt').then(response => response.text().then(data => {
          var liveDate = this.getDateFromUpdateFile(data)
          if (liveDate) {
            var liveUpdateDate = this.moment(liveDate)
            onload(liveUpdateDate)
          }
        }), error => {
          this.error = error
        })
      },
      checkIfBuildFinished (site, updateDate) {
        var minute = 60000
        if (this.interval) {
          clearInterval(this.interval)
        }
        this.interval = setTimeout(() => {
          this.message = 'Checking if new version is live, please wait...'
          this.getLiveDate(site, (newLiveUpdateDate) => {
            console.log(newLiveUpdateDate, updateDate)
            if (newLiveUpdateDate.isAfter(updateDate)) {
              this.message = `New version of ${site.name} is now live!`
              this.loading = false
            } else {
              this.message = 'New version not live yet, checking again in 1 minute. Please wait...'
              this.checkIfBuildFinished(site, updateDate)
            }
          })
        }, minute)
      },
      buildDialog () {
        if (this.loading) {
          this.dialog = true
        } else {
          var site = this.sites.find(site => site.siteId === this.site)
          this.$refs.yesno.open(`Do you want to update ${site.name}?`, `Are you sure you want to update ${site.name}?`)
        }
      },
      getDateFromUpdateFile (text) {
        var i1 = text.lastIndexOf('(')
        var i2 = text.lastIndexOf(')')
        var lastUpdate = text.substring(i1 + 1, i2)
        return lastUpdate
      },
      build (done) {
        done()
        this.tryAgain = false
        this.loading = true
        this.dialog = true
        var site = this.sites.find(site => site.siteId === this.site)
        this.message = `Preparing build for a new version of ${site.name}`

        this.api.get('sites/update/' + this.site).then(result => {
          var lastUpdate = this.getDateFromUpdateFile(result.data)
          if (lastUpdate) {
            var lastUpdateDate = this.moment(lastUpdate)
            this.message = 'Getting live version, please wait...'
            this.getLiveDate(site, (liveUpdateDate) => {
              console.log(lastUpdateDate, liveUpdateDate)
              if (liveUpdateDate.isSame(lastUpdateDate)) {
                this.message = `${site.name} is ready to build, triggering build action...`
                this.api.get('sites/action/' + this.site).then(result => {
                  console.log(result.data)
                  this.message = `A new version of ${site.name} is being build! Please wait...`
                  this.checkIfBuildFinished(site, liveUpdateDate)
                }, error => {
                  this.error = error
                  this.message = 'Couldn\'t trigger build action, please wait and try again or contact BetaCore.'
                  this.tryAgain = true
                  this.loading = false
                })
              } else {
                this.loading = false
                this.tryAgain = true
                this.message = `Another version of ${site.name} is already being build, please wait and try again in a few minutes or contact BetaCore.`
              }
            })
          } else {
            this.message = `Couldn't get latest version of ${site.name}, please contact BetaCore.`
            this.loading = false
          }
        }, error => {
          this.error = error
          this.message = `Couldn't get latest version of ${site.name}, please contact BetaCore.`
          this.loading = false
        })
      }
    }
  }
</script>
